import { StepShell, SectionGroup } from '../components/layout';
import { TextArea } from '../components/inputs';
import { TagSelect } from '../components/selection';

export default function CareerGoalsStep({ data, update, notes = {}, config }) {
  return (
    <StepShell
      eyebrow="Step 11 of 18"
      title="Where you’d like to go"
      lede="You do not need a five-year plan. Most people do not have one, and that is fine — a rough sense of direction is enough."
      why="If we know what you are hoping to get out of this, we can point you at the work and the people most likely to help you get there."
    >
      <TextArea
        id="short_term"
        label="What are you hoping to get out of the next year?"
        rows={3}
        maxLength={600}
        placeholder="A sentence or two is plenty."
        value={data.short_term}
        note={notes.short_term}
        onChange={(v) => update({ short_term: v })}
      />

      <TextArea
        id="long_term"
        label="And further out?"
        optional
        rows={3}
        maxLength={600}
        placeholder="Even a vague direction helps. “I have no idea yet” is an honest answer too."
        value={data.long_term}
        note={notes.long_term}
        onChange={(v) => update({ long_term: v })}
      />

      <SectionGroup label="What matters most to you">
        <TagSelect
          label="Pick whatever you would most like from a programme like this"
          options={config.learningPriorities}
          values={data.learning_priorities || []}
          note={notes.learning_priorities}
          onChange={(v) => update({ learning_priorities: v })}
        />
      </SectionGroup>
    </StepShell>
  );
}
